// extracted by mini-css-extract-plugin
module.exports = {"liveTag":"style_liveTag__dJ7tr","liveTag-dot":"style_liveTag-dot__miRCu","liveTag-text":"style_liveTag-text__3Et9b"};